import { render, staticRenderFns } from "./widgetBarlinechart.vue?vue&type=template&id=63dc8b3c&scoped=true"
import script from "./widgetBarlinechart.vue?vue&type=script&lang=js"
export * from "./widgetBarlinechart.vue?vue&type=script&lang=js"
import style0 from "./widgetBarlinechart.vue?vue&type=style&index=0&id=63dc8b3c&prod&scoped=true&lang=less"
import style1 from "./widgetBarlinechart.vue?vue&type=style&index=1&id=63dc8b3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc8b3c",
  null
  
)

export default component.exports